import { observer } from "mobx-react";
import './onboarding-wizard-sticky-footer.scss';

const OnboardingWizardStickyFooter: React.FC = observer(() => {
    return (
        <div id="onboarding-wizard-sticky-footer" className="onboarding-wizard-sticky-footer"></div>
    );
});

export default OnboardingWizardStickyFooter;